import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import PreordiniPage from '@/pages/preordini/PreordiniPage'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PreordiniPage />} />
        <Route path="/preordini" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
